import { Container, Graphics, type Text } from 'pixi.js';
import { airportTime, clockHands } from '../domain/timetable.js';
import { C, label, rounded, setText } from './primitives.js';

/** Railway-style face: bold indexes, black hands and the red seconds paddle. */
export class AirportClock {
    readonly root = new Container();
    private hands = new Graphics();
    private time: Text;
    /** `height` 58 is the full card; a shorter one is a compact pill (face and time only). */
    constructor(parent: Container, width: number, height = 58) {
        parent.addChild(this.root);
        this.root.name = 'airport-clock';
        const compact = height < 58;
        rounded(this.root, 0, 0, width, height, compact ? height / 2 : 10, C.navy, .96);
        // The dial is drawn at full size and scaled into a compact pill.
        const dial = new Container(), scale = compact ? (height - 8) / 46 : 1;
        dial.scale.set(scale);
        dial.position.set(compact ? 4 + 23 * scale - 28 * scale : 0, compact ? height / 2 - 29 * scale : 0);
        this.root.addChild(dial);
        const face = new Graphics();
        dial.addChild(face);
        face.beginFill(0xffffff).drawCircle(28, 29, 23).endFill();
        for (let i = 0; i < 60; i++) {
            const angle = i / 60 * Math.PI * 2, bold = i % 5 === 0;
            face.lineStyle(bold ? 2.6 : .8, 0x17242c);
            face.moveTo(28 + Math.sin(angle) * (bold ? 16 : 20), 29 - Math.cos(angle) * (bold ? 16 : 20));
            face.lineTo(28 + Math.sin(angle) * 22, 29 - Math.cos(angle) * 22);
        }
        dial.addChild(this.hands);
        if (compact) { this.time = label(this.root, '09:00', height, height / 2 - 8, 14, C.white, '800'); return; }
        this.time = label(this.root, '09:00', 57, 10, width < 150 ? 15 : 22, C.white, '800');
        label(this.root, 'AIRPORT', 57, 36, width < 150 ? 8 : 10, 0xb5ddd5, '700');
    }
    update(frame: number) {
        setText(this.time, airportTime(frame));
        const angles = clockHands(frame), ink = this.hands;
        ink.clear();
        const hand = (angle: number, length: number, width: number, color: number) => {
            ink.lineStyle(width, color).moveTo(28, 29).lineTo(28 + Math.sin(angle) * length, 29 - Math.cos(angle) * length);
        };
        hand(angles.hour, 12, 3.4, 0x17242c);
        hand(angles.minute, 18, 2.4, 0x17242c);
        hand(angles.second, 17, 1.2, 0xd82f39);
        ink.lineStyle(0).beginFill(0xd82f39).drawCircle(28 + Math.sin(angles.second) * 17, 29 - Math.cos(angles.second) * 17, 2.7).endFill();
        ink.beginFill(0x17242c).drawCircle(28, 29, 1.8).endFill();
    }
}
